/**
 * Simple Refer-a-Friend Order Tracking
 * 
 * This script adds the scaaf_aid cookie value to cart attributes
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get the scaaf_aid cookie value
  const scaafAid = getCookie('scaaf_aid');
  
  if (scaafAid) {
    setCartAttribute('UpPromote_Advocate_ID', scaafAid);
  } else {
    // If scaaf_aid cookie is not found, search for up_uppromote_aid cookie
    const upPromoteAid = getCookie('up_uppromote_aid');
    if (upPromoteAid) {
      setCartAttribute('UpPromote_Advocate_ID', upPromoteAid);
    } 
  }
});

/**
 * Set cart attribute using Shopify AJAX API
 */
function setCartAttribute(name, value) {
  const data = {
    attributes: {
      [name]: value
    }
  };
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .catch(error => {
    console.error('Refer-a-Friend: Error setting cart attribute:', error);
  });
}

/**
 * Get cookie value by name
 */
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
} 